import { BaseService } from '../../../infra/base.service'
import type { Board } from './board'
import type { BoardsRepository } from './boards.repository'

export class BoardsService extends BaseService<Board> {
    constructor(private rep: BoardsRepository) {
        super(rep)
    }
}
